import { createFileRoute } from "@tanstack/react-router"
import * as v from "valibot"

import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { routeGuard } from "@/lib/routing/beforeLoad"

import { templateName } from "../-templateQuery"

const searchSchema = v.fallback(
  v.object({
    deviceId: v.optional(v.string())
  }),
  {}
)

export const Route = createFileRoute("/_authlayout/_header/templates/$id/apply/")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, params }) => {
    await routeGuard(context, {
      permission: { flag: "iot:template::apply", fallbackRoute: { to: "/templates/$id", params: { id: params.id } } }
    })
  },
  loader: ({ context }) => context.queryClient.query({ ...getBoardsQueryOptions(), staleTime: "static" }),
  head: ({ match }) => {
    const title = templateName(match.context.templateQuery) || "Template"

    return { meta: [{ title: `Apply ${title} | Arduino Cloud` }] }
  }
})
